import {IBaseFetchOptions, IBaseResponse, IEndpointsMap} from '../ICustomApiConfig';

export const endpointsMap: IEndpointsMap = {
	SEARCH_PROFILE: {
		path: 'search',
		method: 'POST'
	},
	CREATE_PROFILE: {
		path: 'profiles/{c_email}',
		method: 'POST'
	},
	UPDATE_PROFILE: {
		path: 'profiles/{c_email}',
		method: 'PATCH'
	},
	SUBSCRIBE: {
		path: 'profiles/{c_email}/subscription',
		method: 'POST'
	},
	UNSUBSCRIBE: {
		path: 'profiles/{c_email}/subscription',
		method: 'DELETE'
	},
	UNSUBSCRIBE_BY_UID: {
		path: 'profiles/uid/{c_uid}/subscription',
		method: 'DELETE'
	},
	ADD_PREFERENCES: {
		path: 'profiles/{c_email}/trackpreferences',
		method: 'POST'
	}
};

interface IProfileRequestsBody {
	gender?: string | number;
	salutation?: string;
	newsFor?: string | number;
	countryCode?: string;
	source?: string;
	languageCode?: string;
	isSubscribed?: boolean;
	privacyAuthorization?: boolean;
	preferredNewsletterContent?: Array<string>;
	preferredCategories?: Array<string>;
	preferredBrands?: Array<string>;
	followedBrands?: Array<string>;
	authorizationDataCollection?: boolean;
	USConsent?: boolean;
	phoneCode?: string;
	phone?: string;
	contactEmail?: boolean;
	contactSms?: boolean;
	contactWhatsapp?: boolean;
	contactPhone?: boolean;
	brandPreference?: Array<string>;
}

interface ISearchNewsletterProfileBody extends IBaseFetchOptions {
	email: string;
}

// Options
export interface ISearchNewsletterProfileOptions extends IBaseFetchOptions {
	body: ISearchNewsletterProfileBody
}

export interface ICreateNewsletterProfileOptions extends IBaseFetchOptions {
	pathParameters: {
		c_email: string;
	};
	body: IProfileRequestsBody & {
		countryCode: string;
		languageCode: string;
	};
}

export interface IUpdateNewsletterProfileOptions extends IBaseFetchOptions {
	pathParameters: {
		c_email: string;
	};
	body: IProfileRequestsBody;
}

export interface ISubscribeToNewsletterOptions extends IBaseFetchOptions {
	pathParameters: {
		c_email: string;
	};
	body: {
		gender?: string;
		firstName?: string;
		lastName?: string;
		birthday?: string;
		newsFor?: string;
		countryCode: string;
		languageCode: string;
		source?: string;
		subscriptions?: boolean | Array<string>;
		authorizationDataCollection?: boolean;
		USConsent?: boolean;
		acceptsMarketing?: boolean;
		brandPreference?: string[];
		salutation?: string;
		phoneCode?: string;
		phone?: string;
		contactEmail?: boolean;
		contactSms?: boolean;
		contactWhatsapp?: boolean;
		contactPhone?: boolean;
	};
}

export interface IUnsubscribeToNewsletterOptions extends IBaseFetchOptions {
	pathParameters: {
		c_email: string;
	};
	parameters: {
		c_unsubscribeReason?: string;
	};
}

export interface IUnsubscribeFromNewsletterByUidOptions extends IBaseFetchOptions {
	pathParameters: {
		c_uid: string;
	};
}

export interface IAddNewsletterPreferencesOptions extends IBaseFetchOptions {
	pathParameters: {
		c_email: string;
	};
	body: {
		preferences: Array<string>;
	};
}

// Response
export interface ISearchNewsletterProfileResponse extends IBaseResponse {
	newsletterProfile: {
		blacklistStatus: string;
		customerMonetaryValue: string;
		email: string;
		firstName: string;
		isSubscribed: boolean;
		lastName: string;
		privacyAuthorization: boolean;
		gender?: Number;
		newsFor?: string;
		brandPreference?: Array<string>;
		preferredNewsletterContent?: Array<string>;
		preferredCategories?: Array<string>;
		preferredBrands?: Array<string>;
		followedBrands?: Array<string>;
		authorizationDataCollection?: boolean;
	};
}

export interface ICreateNewsletterProfileResponse extends IBaseResponse {
	subscriptionCode: string;
}

export interface IUpdateNewsletterProfileResponse extends IBaseResponse {
	subscriptionCode: string;
}

export interface ISubscribeToNewsletterResponse extends IBaseResponse {
	subscriptionCode: string;
}

export interface IUnsubscribeToNewsletterResponse extends IBaseResponse {
	unsubscriptionStatus: string;
}

export interface IUnsubscribeFromNewsletterByUidResponse extends IBaseResponse {
	unsubscriptionStatus?: string;
}

export interface IAddNewsletterPreferencesResponse extends IBaseResponse {};
